<template>
  <transition name="wishlist-variant" mode="out-in">
    <div
      class="flex flex--between"
      :class="[
        isLoggedIn && isShopTitle ? ' add-initial-bottom-margin' : '',
        isLoggedIn && !isShopTitle ? ' add-initial-top-margin' : '',
      ]"
      :key="currentVariant.Id"
    >
      <button
        v-if="isLoggedIn"
        class="cta__save-link flex flex--align-center"
        s
        :class="[
          isAdded ? 'active' : 'inactive',
          isPremier ? ' cta__save-link--alt' : '',
        ]"
        key="loggedIn"
        @click="toggleList"
      >
        <svg
          width="19px"
          height="17px"
          viewBox="0 0 19 17"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <title>{{ linkText }}</title>
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(1.000000, 1.000000)" stroke="#000000">
              <path
                d="M0,4.79711514 C0,1.97100029 2.0044138,0 4.47730747,0 C6.106024,0 7.03576888,0.319807676 8.31499958,1.59903838 C9.59423029,0.319807676 10.5239752,0 12.1526917,0 C14.6255726,0 16.6299992,1.97100029 16.6299992,4.79711514 C16.6299992,6.00419724 16.2642671,7.11380195 15.6524111,7.98892367 L15.6705761,7.9951919 C14.3913454,9.7007902 12.6380318,11.2173182 10.8849741,12.7333345 C10.0083173,13.4915345 9.13204423,14.2496067 8.31499958,15.0309608 C7.54886831,14.2982174 6.70406435,13.5762196 5.84736355,12.8441159 C4.09910291,11.3503582 2.30235942,9.81540927 1.03031799,8.06324698 C0.352914167,7.11009218 0,5.96582031 0,4.79711514 L0,4.79711514 Z"
              ></path>
            </g>
          </g>
        </svg>
        <span class="type-x-small type-medium-bold">{{ linkText }}</span>
      </button>
    </div>
    <!-- <button
      v-if="!isLoggedIn"
      key="guest"
      class="cta__save-link"
      data-micromodal-trigger="login-modal">
      Log in to add to wishlist
    </button> -->
  </transition>
</template>

<script>
import { mapActions, mapState } from "vuex";

import { GET_WISH_LIST } from "../vuex/modules/add-to-wishlist/mutations";
import { ADD_ITEM_TO_LIST } from "../vuex/modules/add-to-wishlist/mutations";
import { REMOVE_ITEM_FROM_LIST } from "../vuex/modules/add-to-wishlist/mutations";
import { UPDATE_WISH_LIST } from "../vuex/modules/add-to-wishlist/mutations";

export default {
  name: "AddToWishlist",
  props: ["wishlistEnum", "productVariantId", "productId", "isPremier"],

  data() {
    return {
      listId: "",
      isShopTitle: false,
      // isAdded: false,
      titleId: null,
      variantId: null,
    };
  },

  mounted() {
    if (this.wishlistEnum === "shop") this.isShopTitle = true;
    this.listId = this.isShopTitle ? 2 : 3;
    this.getWishlist();
    // console.log(this.productId);
    // console.log(this.productVariantId);
    this.titleId = this.productId;
    this.variantId =
      typeof this.productVariantId !== "undefined"
        ? this.productVariantId
        : this.currentVariant.Id;

    this.$store.commit("setProductVariant", this.variantId);
  },

  methods: {
    ...mapActions({
      GET_WISH_LIST,
      ADD_ITEM_TO_LIST,
      REMOVE_ITEM_FROM_LIST,
      UPDATE_WISH_LIST,
    }),

    getWishlist() {
      const $vm = this;
      this.GET_WISH_LIST(this.listId).then(function() {
        $vm.checkIsAdded();
      });
    },

    checkIsAdded() {
      // console.log(this.wishlist);
      if (!this.isShopTitle) {
        return this.wishlist.find((item) => item.ProductId == this.productId);
      } else {
        return this.wishlist.some(
          (item) => item.ProductVariantId == this.variantId
        );
      }
      // this.isAdded = currentItemAdded;
    },

    toggleList() {
      if (this.checkIsAdded()) {
        this.removeItemFromList();
      } else {
        this.addItemToList();
      }
    },

    removeItemFromList() {
      if (this.wishlist.length <= 0) return;

      const $vm = this;
      this.REMOVE_ITEM_FROM_LIST({
        wishlistId: $vm.listId,
        productId: $vm.titleId,
        productVariantId: $vm.variantId,
      }).then(function() {
        $vm.getWishlist();
      });
    },

    addItemToList() {
      const $vm = this;

      // $vm.isAdded = true;
      this.ADD_ITEM_TO_LIST({
        wishlistId: $vm.listId,
        productId: $vm.titleId,
        productVariantId: $vm.variantId,
      }).then(function() {
        $vm.getWishlist();
      });
    },
  },

  watch: {
    currentVariant() {
      if (this.isShopTitle) {
        this.variantId = this.currentVariant.Id;
        this.$store.commit("setProductVariant", this.variantId);
      }
    },
  },

  computed: {
    ...mapState({
      // isAdded: state => state.addToWishlistStore.isAdded,
      currentVariant: (state) => state.ProductVariantStore.currentVariant,
      wishlist: (state) => state.addToWishlistStore.wishlist,
      wishlistId: (state) => state.addToWishlistStore.wishlistId,
      isLoggedIn: (state) => state.AuthStore.isLoggedIn,
    }),
    // ...mapGetters([
    //   'linkText',
    // ]),

    linkText() {
      return this.isAdded ? "Remove from wishlist" : "Save to wishlist";
    },

    isAdded() {
      return this.checkIsAdded();
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AddToWishlist.vue